export default __webpack_public_path__ + "static/media/fenelon.4a64c718.jpg";